exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlighted[data-v-188ae556] {\n  background-color: darkseagreen;\n}\n.order-product-line-quantity[data-v-188ae556] {\n  text-align: right;\n}\n.order-product-line-total[data-v-188ae556] {\n  text-align: right;\n}", ""]);

// exports
